import React from 'react'
import "./Billboards_and_Hoardings.css"

function Billboards_and_Hoardings({billBoardData}) {
    console.log("billBoardData",billBoardData)
    return (
        <>
            <section className='Billboards_and_Hoardings'>
                <div className='container'>
                    <div className='heading_holder'>
                        <h5>{billBoardData?.title}</h5>
                        <p>{billBoardData?.description}</p>
                    </div>



                    <div className='img_holder'>
                        <img
                            className="Banner_img"
                            src={billBoardData?.image}
                            alt="Banner"
                        />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Billboards_and_Hoardings